const Footer = ({ onOpenDemo }) => {
    return (
        <footer className="bg-gray-900 text-white py-14">
            <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-4 gap-10 mb-10">

                    {/* Brand column */}
                    <div className="md:col-span-2">
                        <div className="flex items-center space-x-2 mb-3">
                            <img src="/logo_lockup_on_dark.svg" alt="StockEasy" className="h-10" />
                        </div>
                        <p className="text-gray-400 text-sm max-w-sm">
                            Innovative AI-powered inventory solutions for car parts businesses. Reduce losses, verify deliveries, and generate reports in seconds.
                        </p>
                        <div className="flex space-x-4 mt-5">
                            <a href="#" className="text-gray-400 hover:text-white transition"><i className="fab fa-linkedin-in"></i></a>
                            <a href="#" className="text-gray-400 hover:text-white transition"><i className="fab fa-twitter"></i></a>
                            <a href="#" className="text-gray-400 hover:text-white transition"><i className="fab fa-facebook-f"></i></a>
                            <a href="#" className="text-gray-400 hover:text-white transition"><i className="fab fa-instagram"></i></a>
                        </div>
                    </div>

                    {/* Product links */}
                    <div>
                        <h4 className="font-semibold text-sm mb-4 text-gray-300 uppercase tracking-widest">Product</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><a href="#features"     className="hover:text-white transition">Features</a></li>
                            <li><a href="#how-it-works" className="hover:text-white transition">How It Works</a></li>
                            <li><a href="#pricing"      className="hover:text-white transition">Pricing</a></li>
                            <li><a href="#faq"          className="hover:text-white transition">FAQ</a></li>
                        </ul>
                    </div>

                    {/* Company links */}
                    <div>
                        <h4 className="font-semibold text-sm mb-4 text-gray-300 uppercase tracking-widest">Company</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><a href="#contact"        className="hover:text-white transition">Contact</a></li>
                            <li><a href="#privacy-policy" className="hover:text-white transition">Privacy Policy</a></li>
                            <li>
                                <button
                                    onClick={onOpenDemo}
                                    className="hover:text-white transition text-left"
                                >
                                    Book a Demo
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>

                <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-xs">
                    <p>&copy; {new Date().getFullYear()} StockEasy. All rights reserved.</p>
                    <p className="mt-2 md:mt-0">{process.env.REACT_APP_VERSION}</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
